import ReactOnRails from 'react-on-rails/client';
import BlogAuthor from '../../bundles/Blog/components/BlogAuthor.client.jsx';

ReactOnRails.register({BlogAuthor});